export default __webpack_public_path__ + "media/images/favicon/favicon-120x120-7bc0685ee96b442fdbde74cbb94d395b.png";